export function createFormHelpers($j, $form) {
  const hide = ($el) => { if ($el && $el.length) $el.hide() }
  const show = ($el) => { if ($el && $el.length) $el.show() }

  const setChecked = (selector, checked) => {
    const $el = $form.find(selector).first()
    if ($el.length) $el.prop("checked", !!checked)
  }

  const clearValue = (selector) => {
    const $el = $form.find(selector).first()
    if ($el.length) $el.val("")
  }

  const uncheckByName = (name) => {
    $form.find(`input[name="${name}"]`).prop("checked", false)
  }

  const parseDateSmart = (value) => {
    const v = (value || "").toString().trim()
    if (!v) return null

    // yyyy-mm-dd
    let m = v.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    if (m) {
      const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
      return isNaN(d.getTime()) ? null : d
    }

    // dd/mm/yyyy
    m = v.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
    if (m) {
      const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]))
      return isNaN(d.getTime()) ? null : d
    }

    const d = new Date(v)
    return isNaN(d.getTime()) ? null : d
  }

  const calcAge = (birthDate) => {
    if (!birthDate) return null
    const today = new Date()

    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--

    return age
  }

  return { $j, $form, hide, show, setChecked, clearValue, uncheckByName, parseDateSmart, calcAge }
}
